module.exports = __webpack_public_path__ + "static/media/infografika_2-mi.759fde2a.png";